// This file is auto-generated by scripts/update-version.js
// Do not edit this file manually
// Generated on: 2026-05-07T04:40:08.429Z

export const VERSION = '2.0.20250904';
export const BUILD_DATE = '20260507.0440';
